<ng-container [ngSwitch]="settingsService.getSetting('ScrollToTopButton')">
  <app-scroll-to-top-button-default *ngSwitchDefault></app-scroll-to-top-button-default>
  <app-scroll-to-top-button-roskamp *ngSwitchCase="'roskamp'"></app-scroll-to-top-button-roskamp>
</ng-container>

